/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-unused-vars */
import {
  ComponentChildSchema,
  assignedTranslateValues,
  getTranslatedText,
  withCustomizeSchema,
} from '@nizza/customize-live';
import { getFingerprint } from '@nizza/utils';
import clsx from 'clsx';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import {
  ActionsContext,
  SettingContext,
  useControlsContext,
  useLivestreamingContext,
} from '../../context';
import type { Message } from '../../types';
import {
  WC_NAME,
  getDeviceType,
  getElementById,
  querySelectorAll,
} from '../../utils';
import { intlFormatMessageOutsideFC } from '../../utils/intlFormatMessageOutsideFC';
// import GiphySearch from '../Giphy/Giphy';
import { OpenQuestionButton, Question } from '../Question_v2';
import AnimatedLoaderIcon from '../icons/AnimatedLoaderIcon';
import ArrowDown from '../icons/ArrowDown';
import ChatIcon from '../icons/ChatIcon';
// import GifIcon from '../icons/GifIcon';
import SendIcon from '../icons/Send';
import { MessageInputAlert } from './MessageInputAlert';
import MessageRenderer from './MessageRenderer';
import styles from './chat.module.css';
import { Login } from './login/Login';

const intl = intlFormatMessageOutsideFC();

type ChatProps = {
  pinnedMessage: Message | undefined;
  transmitionType: string | undefined;
  initShowGif: boolean | undefined;
  livestreamingStatus: string | undefined;
  isVerticalLayout: boolean;
  fullScreen: boolean;
  hideChat: boolean;
  setUnreadMessages: React.Dispatch<React.SetStateAction<number>>;
};

const NUMBER_OF_PREVIOUS_MESSAGES = 25;

export const Chat = ({
  pinnedMessage,
  transmitionType,
  initShowGif,
  livestreamingStatus,
  isVerticalLayout,
  fullScreen,
  hideChat,
  setUnreadMessages,
}: ChatProps) => {
  const { formatMessage } = useIntl();
  const chatAreaRef = useRef<HTMLDivElement>(null);
  const formContainer = useRef<HTMLFormElement>(null);
  const [content, setContent] = useState<string>('');
  const [chatFiltered, setChatFiltered] = useState<Message[]>([]);
  const [showLoginWindow, setShowLoginWindow] = useState(false);
  const [sendFirstMessage, setSendFirstMessage] = useState(false);
  const [userIsLoggedInChat, setUserIsLoggedInChat] = useState(false);
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [incoming, setIncoming] = useState(false);
  const [incomingPosition, setIncomingPosition] = useState(0);
  const isMobile = getDeviceType() === 'mobile';
  const IS_DESKTOP = !isMobile;
  const [, /*showGif*/ setShowGif] = useState(false);
  const [, /*showGifButton*/ setShowGifButton] = useState<boolean | undefined>(
    false,
  );
  const [selectedGif, setSelectedGif] = useState<string>();
  const [fisrtLoad, setFirstLoad] = useState(true);
  const [bannedUser, setBannedUser] = useState(false);
  const [finishLive, setFinishLive] = useState(false);
  const [deleteMessageFlag, setDeleteMessageFlag] = useState(false);
  const [chatMessagesBeforeHide, setChatMessagesBeforeHide] = useState<
    Message[]
  >([]);
  const [hideChatValue, setHideChatValue] = useState(false);
  const [heightChat, setHeightChat] = useState(274);
  const chatRef = useRef<HTMLInputElement>(null);
  const [inputChatBlurTimeOut, setInputChatBlurTimeOut] =
    useState<NodeJS.Timeout>();
  const userLogin = localStorage.getItem('userIsLoggedInChat');
  const { username, email } = JSON.parse(userLogin ? userLogin : '{}');

  const {
    infoSocket,
    ivsChatSocket,
    isModalLive,
    showCarouselChat,
    collectionId,
  } = useContext(SettingContext);
  const { chat: chatFinalizedEvents, account } = useLivestreamingContext();

  const { socket, showLoader, setShowLoader, chat, setChat } =
    ivsChatSocket || {};

  const {
    sessionId,
    messageToDelete,
    setMessageToDelete,
    showGif: showGifButtonSocket,
  } = infoSocket || {};

  const {
    setting: { idLivestreaming, showSidebarProducts, isInGlobalPage },
  } = useContext(ActionsContext);

  const {
    isChatFocus,
    setIsChatFocus,
    questionTime,
    setHideQuestion,
    hideQuestion,
  } = useControlsContext();

  const isMobileHorizontal = isMobile && !isVerticalLayout;
  const isMobileVertical = isMobile && isVerticalLayout;

  const handleIncoming = (): void => {
    if (!chatAreaRef?.current) return;

    chatAreaRef.current.scrollBy(
      0,
      chatAreaRef.current.scrollHeight - chatAreaRef.current.clientHeight,
    );

    chatAreaRef.current.scrollBy(0, 0);
    setIncoming(false);
  };

  const handlerSendMessage = async (
    event?: React.SyntheticEvent,
    type = 'string',
    gif?: string,
  ) => {
    if (event) {
      event.preventDefault();
      event.persist();
    }

    if (setShowLoader === undefined) return;
    if (bannedUser) {
      setContent('');
      return;
    }

    setShowLoader(true);
    const isEmpty = !(content !== null && content.trim() !== '');
    const isEmptyGif = gif === undefined || gif?.trim() === '';

    if ((isEmpty && isEmptyGif) || !socket) {
      setShowLoader(false);
      return;
    }

    if (!userIsLoggedInChat) {
      setTimeout(() => setShowLoginWindow(true), 200);
      setSelectedGif(gif);
      setShowGif(false);
      setShowLoader(false);
      return;
    }

    const data = {
      action: 'SEND_MESSAGE',
      content:
        type === 'gif'
          ? gif
          : content.replace(/\\/g, '\\\\').replace(/"/g, '\\"') || gif,
      attributes: {
        id: uuidv4(),
        account,
        idEvent: idLivestreaming,
        sessionId: sessionId,
        email,
        username,
        type,
        fingerprint: getFingerprint(),
        language: navigator.language,
      },
    };

    socket.send(JSON.stringify(data));
    if (type !== 'gif') {
      setContent('');
    } else {
      setShowGif(false);
    }

    handleKeepChatInputFocused();
    setTimeout(() => setShowLoader(false), 1000);
  };

  const handleKeepChatInputFocused = (preserveFocus = true) => {
    inputChatBlurTimeOut && clearTimeout(inputChatBlurTimeOut);
    const inputChat = getElementById('liveshopping_input_chat');
    if (preserveFocus) {
      inputChat && inputChat.focus();
    } else {
      userIsLoggedInChat && inputChat && inputChat.blur();

      setTimeout(() => {
        const inputChatName = getElementById('name');
        inputChatName && inputChatName.blur();
        inputChatName && inputChatName.focus();
      }, 1000);
    }

    setIsChatFocus && setIsChatFocus(true);
  };

  // const handleKeepChatInputFocusedStyles = () => {
  //   inputChatBlurTimeOut && clearTimeout(inputChatBlurTimeOut);
  //   setIsChatFocus && setIsChatFocus(true);
  // };

  const handleHideMessageUntilChatUpdate = (resetStyles?: boolean) => {
    if (!resetStyles) {
      // hide deleted message until next update
      const messageElements = querySelectorAll(
        `.${styles.chatBubbleContainer}`,
      );
      if (messageElements && messageElements.length > 0) {
        for (let i = 0; i < messageElements.length; i++) {
          const El = messageElements.item(i);
          const msgTextContent = El?.textContent;
          if (
            El &&
            msgTextContent &&
            typeof msgTextContent == 'string' &&
            messageToDelete?.username &&
            messageToDelete?.data
          ) {
            if (
              messageToDelete.isAdmin &&
              messageToDelete.question?.data &&
              messageToDelete.question?.username
            ) {
              if (
                msgTextContent.includes(messageToDelete.username) &&
                msgTextContent.includes(messageToDelete.question.data) &&
                msgTextContent.includes(messageToDelete.question.username)
              ) {
                El.setAttribute('style', 'height: 0px; overflow: hidden;');
              }
            } else {
              if (
                msgTextContent.includes(messageToDelete.username) &&
                msgTextContent.includes(messageToDelete.data)
              ) {
                El.setAttribute('style', 'height: 0px; overflow: hidden;');
              }
            }
          }
        }
      }
    } else if (resetStyles) {
      // reset styles for deleted message until next update
      const messageElements = querySelectorAll(
        `.${styles.chatBubbleContainer}`,
      );
      if (messageElements && messageElements.length > 0) {
        for (let i = 0; i < messageElements.length; i++) {
          const El = messageElements.item(i);
          El && El.removeAttribute('style');
        }
      }
    }
  };

  const isVisibleGift = (): boolean => {
    const e = document
      ?.querySelector<HTMLElement>(WC_NAME)
      ?.shadowRoot?.querySelector<HTMLElement>(
        "div[class*='giphySearchBoxContainer']",
      );
    return !!(e?.offsetWidth || e?.offsetHeight || e?.getClientRects().length);
  };

  const getSpaceTopElementsSticky = () => {
    try {
      const collectionElSticky = document.getElementsByClassName('sticky');
      const collectionElStickyTop = [...collectionElSticky]
        .map(el => {
          const { top, height } = el.getBoundingClientRect();
          if (top < 150) {
            return { ...el, topSpace: top + height };
          }
          return null;
        })
        .filter(element => element !== null);
      if (!collectionElStickyTop.length) return 0;
      const { topSpace } = collectionElStickyTop.at(-1)!;
      return topSpace;
    } catch (error) {
      return 0;
    }
  };

  const handleScrollReset = (isBlur: boolean) => {
    if (!userIsLoggedInChat && showLoginWindow) return;

    const player = getElementById('in-view-nizza-player');

    if (isModalLive || !player || !isMobile || isVisibleGift()) return;

    const topSpace = getSpaceTopElementsSticky();
    if (topSpace > 0)
      window.scroll({
        top: topSpace - 60,
        behavior: 'smooth',
      });
    else player.scrollIntoView(isBlur);
  };

  const deleteMessage = useCallback(() => {
    if (
      !chat ||
      chat?.length === 0 ||
      !messageToDelete ||
      !setMessageToDelete ||
      !setChat
    ) {
      return;
    }

    let newChat = chat.filter(
      (row: Message) =>
        row.username !== messageToDelete?.username ||
        row.data !== messageToDelete?.data,
    );

    setDeleteMessageFlag(true);

    if (messageToDelete.all) {
      newChat = chat.filter(
        (row: Message) => row.username !== messageToDelete?.username,
      );

      setBannedUser(username === messageToDelete.username);
    }

    setChat(newChat);
    setMessageToDelete(undefined);
  }, [messageToDelete]);

  useEffect(() => {
    if (!livestreamingStatus) return;

    if (livestreamingStatus !== 'FINALIZED') {
      setFinishLive(false);
    } else {
      setFinishLive(true);
    }
  }, [livestreamingStatus]);

  useEffect(() => {
    if (!chat || messageToDelete === undefined) return;
    deleteMessage();
    handleHideMessageUntilChatUpdate();
  }, [messageToDelete]);

  useEffect(() => {
    if (scrolled && deleteMessageFlag) {
      setIncoming(false);
      setDeleteMessageFlag(false);
    }

    if (scrolled && !deleteMessageFlag) setIncoming(true);
  }, [chat]);

  const ChatMessages = useMemo(
    () =>
      MessageRenderer(
        infoSocket?.socket ? chatFiltered : chatFinalizedEvents || [],
        isVerticalLayout,
      ),
    [chatFiltered, chat, chatFinalizedEvents],
  );

  useEffect(() => {
    if (hideChat) {
      handleIncoming();
      setHideChatValue(hideChat);
      setChatMessagesBeforeHide(
        chatFiltered.slice(0, NUMBER_OF_PREVIOUS_MESSAGES),
      );
    } else if (!hideChat) {
      setHideChatValue(hideChat);
      setChatMessagesBeforeHide([]);
    }
  }, [hideChat]);

  useEffect(() => {
    if (hideChat) {
      let sumOfunUnreadMessages = 0;
      for (const msg of chatFiltered) {
        let isInBeforeHide = false;
        for (const msgB of chatMessagesBeforeHide) {
          if (
            msg.username === msgB.username &&
            msg.data === msgB.data &&
            msg.sendDate === msgB.sendDate
          ) {
            isInBeforeHide = true;
          }
        }
        if (!isInBeforeHide) sumOfunUnreadMessages += 1;
      }
      setUnreadMessages(sumOfunUnreadMessages);
    }
  }, [chatFiltered]);

  useEffect(() => {
    if (!chat || !chatAreaRef?.current || scrolled) return;
    setChatFiltered(chat.slice(0, NUMBER_OF_PREVIOUS_MESSAGES));
    handleHideMessageUntilChatUpdate(true);
  }, [chat, scrolled]);

  useEffect(() => {
    if (!chatAreaRef?.current) return;

    chatAreaRef.current.scrollTop = -1;
    chatAreaRef.current.scrollTop = 0;
  }, [chatFiltered]);

  useEffect(() => {
    if (!setChat || scrolled) return;

    const interval = setInterval(
      () =>
        setChat((prev: Message[]) =>
          prev.length > NUMBER_OF_PREVIOUS_MESSAGES
            ? prev.slice(0, NUMBER_OF_PREVIOUS_MESSAGES)
            : prev,
        ),
      10000,
    );

    return () => clearInterval(interval);
  }, [setChat, scrolled]);

  useEffect(() => {
    const isLogged = localStorage.getItem('userIsLoggedInChat');

    if (!isLogged) return;
    const userLoggedStorage = JSON.parse(isLogged);

    if (userLoggedStorage.id !== idLivestreaming) return;

    setUserIsLoggedInChat(true);
    setShowLoginWindow(false);
  }, [idLivestreaming]);

  useEffect(() => {
    if (!chatAreaRef?.current) return;
    if (!formContainer?.current) return;

    const config = { attributes: false, childList: true, subtree: false };
    const sizeObeserver = new ResizeObserver((entry: ResizeObserverEntry[]) => {
      const { height } = entry[0].target.getBoundingClientRect();

      setIncomingPosition(height + 5);
    });

    const mutationObs = new MutationObserver((mutations: MutationRecord[]) => {
      const target = mutations[0].target as HTMLDivElement;

      target.scrollBy(0, target.scrollHeight - target.clientHeight);
    });

    mutationObs.observe(chatAreaRef.current, config);
    sizeObeserver.observe(formContainer.current);

    chatAreaRef.current.addEventListener(
      'scroll',
      event => {
        const { scrollTop } = event.target as HTMLDivElement;

        setScrolled(scrollTop < 0);
        if (scrollTop >= 0) setIncoming(false);
      },
      { passive: true },
    );
    return () => {
      mutationObs.disconnect();
      sizeObeserver.disconnect();
      chatAreaRef?.current?.removeEventListener('scroll', () => null);
    };
  }, []);

  useEffect(() => {
    if (fisrtLoad) {
      if (initShowGif === undefined) return;
      setShowGifButton(initShowGif);
      setFirstLoad(false);
    } else {
      if (showGifButtonSocket === undefined) {
        setShowGifButton(initShowGif);
        return;
      }
      setShowGifButton(showGifButtonSocket);
    }
  }, [initShowGif, fisrtLoad, showGifButtonSocket]);

  useEffect(() => {
    if (!isChatFocus) {
      setShowGif(false);
    }
  }, [isChatFocus]);

  const distanceBetweenElements = () => {
    const [carouselEl] = querySelectorAll('#chatcarouselmobile');
    const videoEl = getElementById('player-video-el');
    const noVideoEl = getElementById('no-video');

    const elToCalcDist = carouselEl || videoEl || noVideoEl;

    let distance = -1;

    const { bottom: bottomCarouselOrVideo = 0 } =
      elToCalcDist?.getBoundingClientRect() || {};
    const { top: topChat = 0 } =
      chatRef?.current?.getBoundingClientRect() || {};

    const xDistance = topChat - bottomCarouselOrVideo - 10;

    distance = Math.sqrt(xDistance * xDistance);

    setHeightChat(distance);
  };

  const setHeight = (node: HTMLDivElement) => {
    const canApplied = node && isMobileHorizontal;
    if (canApplied && isModalLive) {
      node.style.setProperty('height', `${heightChat}px`, 'important');
      distanceBetweenElements();
    }
    if (canApplied && !isModalLive) node.style.removeProperty('height');
  };

  const { highlightProduct: highlightProductSocket } = infoSocket || {};

  return (
    <div
      className={`${styles.chatContainer} ${
        isMobileVertical && styles.chatMobileVertical
      } ${isMobileHorizontal && styles.chatContainerMobileHorizontal}
      ${
        (isMobileVertical ||
          (isMobileHorizontal &&
            livestreamingStatus === 'FINALIZED' &&
            !fullScreen)) &&
        hideChatValue &&
        styles.hideChat
      }`}
      style={
        isModalLive && transmitionType === 'vertical' && !isMobile
          ? { maxWidth: 390, minWidth: 390 }
          : {}
      }
    >
      {!isMobile && (
        <div
          className={styles.chatQuestionWrapper}
          style={{
            zIndex: hideQuestion ? 8 : 9,
          }}
        >
          <div className={styles.chatQuestionWrapperPadding}>
            <Question isMobile={false} isVerticalLayout={false} />
          </div>
        </div>
      )}
      <div className={styles.liveChatContainer}>
        <div className={`${styles.chatHeaderQuestionWrapper}`}>
          {hideQuestion && !!questionTime && (
            <div className={styles.chatHeaderQuestionButtonWrapper}>
              <OpenQuestionButton
                isDark
                isInRow
                currentTimeSeconds={questionTime}
                onPress={() => {
                  setHideQuestion(false);
                }}
              />
            </div>
          )}
          {hideQuestion && <MessageHeader />}
        </div>
      </div>

      {!(isMobile && isVerticalLayout && !hideQuestion) && (
        <div
          id="chat_id"
          className={styles.chatContent}
          style={{ scrollMarginBottom: 50 }}
        >
          <div
            ref={setHeight}
            className={clsx(
              styles.messagesContainer,
              isMobileHorizontal && styles.messagesContainerMobileHorizontal,
              isMobileHorizontal &&
                !collectionId &&
                styles.messagesContainerMobileHorizontalNoCarousel,
              isMobileHorizontal &&
                !showSidebarProducts &&
                highlightProductSocket?.products.length === 0 &&
                styles.messagesContainerMobileHorizontalDisableCarousel,
              isMobileHorizontal &&
                fullScreen &&
                !isModalLive &&
                styles.msgsContainerMobileHorizontalFullScreen,
              isMobileHorizontal &&
                fullScreen &&
                !collectionId &&
                styles.msgsContainerMobileHorizontalNoCarouselFullScreen,
            )}
          >
            {pinnedMessage &&
              pinnedMessage?.data &&
              IS_DESKTOP &&
              (hideQuestion || questionTime === 0) && (
                <div className={styles.liveChatPinnedMessage}>
                  {MessageRenderer([pinnedMessage], isVerticalLayout, true)}
                </div>
              )}

            <div
              className={`${styles.chatArea} ${
                isMobile && !isVerticalLayout && styles.chatAreaMobileHorizontal
              }`}
              ref={chatAreaRef}
            >
              {ChatMessages}
            </div>

            {pinnedMessage && pinnedMessage?.data && !IS_DESKTOP && (
              <div
                className={`${styles.liveChatPinnedMessage} ${
                  isMobile &&
                  !isVerticalLayout &&
                  styles.liveChatPinnedMessageMobileHorizontal
                }`}
              >
                <div className={styles.chatArea}>
                  {MessageRenderer([pinnedMessage], isVerticalLayout, true)}
                </div>
              </div>
            )}

            {incoming && (
              <div
                className={styles.chatIncomingWrapper}
                style={{
                  bottom: showCarouselChat ? 0 : incomingPosition,
                  height: IS_DESKTOP ? 40 : 30,
                  justifyContent: IS_DESKTOP ? 'center' : 'flex-start',
                }}
              >
                <div
                  role="button"
                  tabIndex={0}
                  onClick={handleIncoming}
                  className={styles.chatIncomingContainer}
                  aria-label="Chat incoming container"
                  style={{
                    backgroundColor: IS_DESKTOP ? '#2e2e2e' : '#ffffff',
                    color: IS_DESKTOP ? '#f3f3f3' : '#585858',
                  }}
                >
                  <ArrowDown size={IS_DESKTOP ? 24 : 18} />
                  <span
                    style={{
                      marginLeft: 5,
                      fontSize: IS_DESKTOP ? 'unset' : '12px',
                    }}
                  >
                    {formatMessage({ id: 'store/text.unread-messages' })}
                  </span>
                </div>
              </div>
            )}
          </div>
          {showLoginWindow && (
            <Login
              setShowLoginWindow={setShowLoginWindow}
              setUserIsLoggedInChat={setUserIsLoggedInChat}
              setSendFirstMessage={setSendFirstMessage}
              content={content}
              setContent={setContent}
              selectedGif={selectedGif}
            />
          )}

          {isMobile && !isVerticalLayout && (
            <Question isMobile={true} isVerticalLayout={false} />
          )}
          {socket && (
            <div ref={chatRef} className={styles.inputChatMainContainer}>
              {/* <GiphySearch
                handleKeepChatInputFocusedStyles={
                  handleKeepChatInputFocusedStyles
                }
                handleKeepChatInputFocused={handleKeepChatInputFocused}
                showGif={showGif}
                sendGif={handlerSendMessage}
                isChatFocus={isChatFocus}
              /> */}
              <MessageInputAlert message={content} />

              <form
                onSubmit={async (e: React.SyntheticEvent) => {
                  handlerSendMessage(e);
                }}
                className={`${styles.inputChatContent} ${
                  isMobileHorizontal &&
                  isChatFocus &&
                  styles.inputChatContentMobileHorizontalFocus
                } ${
                  isMobileVertical &&
                  isChatFocus &&
                  styles.inputChatContentMobileVerticalFocus
                }`}
                ref={formContainer}
              >
                <div
                  className={`${styles.inputContent} ${
                    isMobile && styles.inputContentMobileFocus
                  }`}
                >
                  {(!isMobileVertical ||
                    (!isInGlobalPage &&
                      isMobileVertical &&
                      (hideQuestion || questionTime === 0))) && (
                    <InputChat
                      className={`${styles.inputTextChat} ${
                        isMobileHorizontal &&
                        styles.inputTextChatMobileHorizontal
                      } ${
                        isMobile &&
                        !isChatFocus &&
                        styles.inputTextChatMobileNoFocus
                      } ${
                        isMobileVertical &&
                        !isChatFocus &&
                        styles.inputTextChatMobileNoFocusVertical
                      }`}
                      placeholder={formatMessage({
                        id: 'store/text.chat-placeholder',
                      })}
                      name="content"
                      type="text"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (e.target.value.length > 180) return;
                        setContent(e.target.value);
                      }}
                      onClick={() => {
                        setIsChatFocus && setIsChatFocus(true);
                      }}
                      onFocus={() => {
                        setShowLoginWindow(
                          !userIsLoggedInChat && sendFirstMessage,
                        );
                        setIsChatFocus && setIsChatFocus(true);
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          handleScrollReset(true);
                        }, 100);
                        const x = setTimeout(() => {
                          setIsChatFocus && setIsChatFocus(false);
                        }, 200);
                        setInputChatBlurTimeOut(x);
                      }}
                      value={content}
                      autoComplete="off"
                      disabled={bannedUser || finishLive}
                    />
                  )}
                </div>
                <div
                  className={`${styles.buttonsChat} ${
                    isMobile
                      ? isChatFocus
                        ? styles.buttonsChatMobileHorizontalFocus
                        : styles.displayNone
                      : ''
                  }`}
                >
                  {/* FIXME: Se oculta temporalmente hasta después de Colombia moda */}
                  {/* {showGifButton && (
                    <span
                      onClick={() => {
                        handleKeepChatInputFocused();
                        handleShowGif();
                      }}
                      className={`${styles.gifIconContainer} ${isMobile &&
                        !isVerticalLayout &&
                        styles.gifIconContainerMobileHorizontal
                        }`}
                    >
                      <GifIcon
                        isMobile={isMobile}
                        viewBox="0 0 22 10"
                        size="25"
                      />
                    </span>
                  )} */}
                  <SendButton
                    handleKeepChatInputFocused={handleKeepChatInputFocused}
                    formatMessage={formatMessage}
                    isMobile={isMobile}
                    showLoader={showLoader}
                    isVerticalLayout={isVerticalLayout}
                  />
                </div>
              </form>
            </div>
          )}
        </div>
      )}
      <div
        style={{
          opacity: 1,
          visibility:
            isMobile && isVerticalLayout && !hideQuestion
              ? 'visible'
              : 'hidden',
          position: 'absolute',
          bottom: 0,
        }}
      >
        <Question isMobile={true} isVerticalLayout={true} />
      </div>
    </div>
  );
};

const MessageHeader = withCustomizeSchema(
  ({ selector, formData }: ComponentChildSchema<unknown>) => {
    return (
      <div className={styles.liveChatHeader}>
        <ChatIcon />
        <p customize-field={selector} className={styles.liveChatText}>
          {getTranslatedText(formData?.data?.sectionTitleDesktop)}
        </p>
      </div>
    );
  },
  {
    chat: {
      id: 'section_title_desktop',
      category: 'desktop',
      label: intl.formatMessage({
        id: 'customize/chat.chat-section-title',
      }),
      fields: {
        type: 'object',
        properties: {
          sectionTitleDesktop: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/general.section-name',
            }),
            default: assignedTranslateValues({
              en: 'Chat',
              pt: 'Bater papo',
              es: 'Chat',
              ro: 'Chat',
            }),
          },
        },
      },
      ui: {
        sectionTitleDesktop: {
          'ui:widget': 'translatableText',
        },
      },
    },
  },
);

const InputChat = withCustomizeSchema(
  (
    props: ComponentChildSchema<
      React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
      >
    >,
  ) => {
    return (
      <input
        {...props}
        placeholder={getTranslatedText(
          props.formData?.data?.sectionPlaceholderInput,
        )}
        customize-field={props.selector}
        id="liveshopping_input_chat"
      />
    );
  },
  {
    chat: {
      id: 'placeholder_input',
      label: intl.formatMessage({
        id: 'customize/chat.comment-box-title',
      }),
      category: 'mix',
      fields: {
        type: 'object',
        properties: {
          sectionPlaceholderInput: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/chat.comment-box-text',
            }),
            default: assignedTranslateValues({
              en: 'Write a comment',
              pt: 'Escreva um comentário',
              es: 'Escribe un comentario',
              ro: 'Lasǎ un comentariu',
            }),
          },
        },
      },
      ui: {
        sectionPlaceholderInput: {
          'ui:widget': 'translatableText',
        },
      },
    },
  },
);

type SendButton = {
  handleKeepChatInputFocused: (preserveFocus?: boolean) => void;
  formatMessage: (descriptor: any, values?: any, opts?: any) => string;
  isMobile: boolean;
  showLoader?: boolean;
  isVerticalLayout: boolean;
};

const SendButton = withCustomizeSchema(
  ({
    selector,
    formData,
    handleKeepChatInputFocused,
    formatMessage,
    isMobile,
    showLoader,
    isVerticalLayout,
  }: ComponentChildSchema<SendButton>) => {
    return (
      <button
        customize-field={selector}
        type="submit"
        className={`${styles.btn} ${
          isMobile && !isVerticalLayout && styles.btnMobileHorizontal
        } ${showLoader && isMobile && styles.btnMobileDisabled}`}
        style={{
          background:
            !isMobile && formData?.data?.backgroundColor
              ? formData?.data?.backgroundColor
              : '',
        }}
        aria-label="Send message"
        onClick={() => {
          handleKeepChatInputFocused(false);
        }}
      >
        {!isMobile ? (
          showLoader ? (
            <AnimatedLoaderIcon
              color={formData?.data?.iconColor}
              className={styles.spinner}
            />
          ) : (
            <SendIcon
              color={formData?.data?.iconColor}
              size="21"
              viewBox="0 0 21 21"
            />
          )
        ) : (
          <div style={{ whiteSpace: 'nowrap' }}>
            {formatMessage({ id: 'store/button.send' })}
          </div>
        )}
      </button>
    );
  },
  {
    chat: {
      id: 'button_send_message_desktop',
      label: intl.formatMessage({
        id: 'customize/chat.send-message-button.desktop.title',
      }),
      category: 'desktop',
      fields: {
        type: 'object',
        properties: {
          backgroundColor: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/general.background',
            }),
            default: '#151ce6',
          },
          iconColor: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/general.icon',
            }),
            default: '#ffff',
          },
        },
      },
      ui: {
        backgroundColor: {
          'ui:widget': 'color',
        },
        iconColor: {
          'ui:widget': 'color',
        },
      },
    },
  },
);
